export const environment = {
  production: true,
  proxyUrl: '',
  serviceUrl: 'https://service.dofbasen.dk/DofBasenService/',
  client_id: 8, 
  client_secret: 'angular-cli-secret'
};



// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/environments/environment.ts